import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import { Container, Col, Row } from 'reactstrap';
import Breadcrumbs from '../../../layout/Breadcrumbs';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import ParcelForm from './ParcelForm';
import { postParcel } from '../../../../actions';
import { CARGO_PATH } from '../../../../config/paths';
import { CREDIT_NOTE } from '../../../../config/constants';

export class NewParcel extends Component {
  onSubmit = (
    formValues,
    hasDelivery,
    isDiscountCodeChecked,
    listPrice,
    remainingPrice,
  ) => {
    const transactions = [];

    const {
      voucherType,
      sourceLocation,
      destinationLocation,
      senderCustomer,
      consigneeCustomer,
      paymentMethod,
      note,
      cargaItems,
      customer,
      business,
      corporateCreditAmount,
      salePrice,
      nextPaymentMethod,
      creditNotes,
    } = formValues;
    if (creditNotes && creditNotes.length !== 0) {
      if (
        paymentMethod.transactionCode === CREDIT_NOTE &&
        creditNotes.length === 0
      ) {
        toastr.error('Error', 'No se ha aplicado ninguna nota de crédito');
        return;
      }
      let currentRemainingPrice = remainingPrice;
      creditNotes
        .sort((a, b) => a.amount - b.amount)
        .forEach((creditNote) => {
          let creditNoteAmount = 0;
          if (currentRemainingPrice === 0) return;
          if (currentRemainingPrice > creditNote.amount) {
            currentRemainingPrice -= creditNote.amount;
            creditNoteAmount = creditNote.amount;
          } else {
            creditNoteAmount = currentRemainingPrice;
            currentRemainingPrice = 0;
          }
          const creditNoteTransaction = {
            customerId: customer ? customer.value : senderCustomer.value,
            paymentMethodId: paymentMethod.value,
            creditNoteId: creditNote.value,
            voucherTypeId: voucherType.value,
            voucherCode: formValues.voucherCode || null,
            businessId: business ? business.value : null,
            amount: creditNoteAmount,
          };
          transactions.push(creditNoteTransaction);
        });
      if (
        currentRemainingPrice !== 0 ||
        paymentMethod.transactionCode !== CREDIT_NOTE
      ) {
        const transaction = {
          customerId: customer.value,
          paymentMethodId: nextPaymentMethod
            ? nextPaymentMethod.value
            : paymentMethod.value,
          voucherTypeId: voucherType.value,
          businessId: business ? business.value : null,
          amount: currentRemainingPrice,
        };
        transactions.push(transaction);
      }
    }
    const newFormValues = {
      ...formValues,
      voucherTypeId: voucherType.value,
      sourceCityId: sourceLocation.city.id,
      sourceLocationId: sourceLocation.value,
      destinationCityId: destinationLocation.city.id,
      destinationLocationId: destinationLocation.value,
      senderCustomerId: senderCustomer.value,
      consigneeCustomerId: consigneeCustomer.value,
      paymentMethodId: paymentMethod.value,
      comments: note,
      cargoItemList: cargaItems.map((item) => ({
        cargoCategoryId: item.cargoCategoryId
          ? item.cargoCategoryId.value
          : null,
        commonProductId: item.commonProductId
          ? item.commonProductId.value
          : null,
        description: item.description,
        listPrice: item.listPrice,
        salePrice: item.salePrice,
        quantity: item.quantity,
        weight: item.weight,
        length: item.length,
        width: item.width,
        height: item.height,
        perishable: !!item.perishable,
      })),
      listPrice,
      salePrice,
      customerId: customer ? customer.value : null,
      businessId: business ? business.value : null,
      discountCodeString: isDiscountCodeChecked
        ? formValues.discountCode
        : null,
      salesPriceWithDiscount:
        isDiscountCodeChecked || corporateCreditAmount
          ? parseFloat(formValues.discountPrice)
          : null,
      contingencyMotive: formValues.contingencyMotive
        ? formValues.contingencyMotive.value
        : null,
      attachedDocumentList: formValues.attachedDocuments
        ? formValues.attachedDocuments.map((document) => ({
            attachedDocumentCorrelation: document.attachedDocument,
          }))
        : [],
      transactionList: transactions,
      corporateCreditAmount: corporateCreditAmount || null,
    };
    if (formValues.secondaryConsignee) {
      newFormValues.secondaryConsigneeCustomerId =
        formValues.secondaryConsigneeCustomer.value;
    }
    if (hasDelivery) {
      newFormValues.deliveryDistrictId = formValues.district.value;
    }
    this.props.dispatchPostParcel(newFormValues);
  };

  render() {
    const { breadcrumbs } = this.props;
    return (
      <Container fluid>
        <Breadcrumbs breadcrumbs={breadcrumbs} />
        <Row>
          <Col>
            <h1>Recepción de Carga</h1>
            <p>Crear nueva Recepción de Carga.</p>
          </Col>
        </Row>
        <ParcelForm onSubmit={this.onSubmit} />
      </Container>
    );
  }
}

const mapStateToProps = ({ CargoUnit }) => ({
  breadcrumbs: [
    ...CargoUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Carga',
      href: CARGO_PATH,
    },
    {
      text: 'Recepción de Carga',
      href: '',
    },
  ],
});

const mapDispatchToProps = { dispatchPostParcel: postParcel };

NewParcel.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchPostParcel: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(NewParcel);
